

    import { defineComponent, PropType, ref, computed } from 'vue';
    import FilterMultiChoice from './FilterMultiChoice.vue';
    import FilterMinMax from './FilterMinMax.vue';
    import { useStore } from '@/catalog-app/store';
    import { AnyFilter, Category } from '@/catalog-app/types';


    export default defineComponent({

        components: { FilterMultiChoice, FilterMinMax },

        props: {
            brand: {
                type: Object as PropType<Category>,
                required: false,
            },
            category: {
                type: Object as PropType<Category>,
                required: false,
            },
            subcategories: {
                type: Object as PropType<Category[]>,
                required: true,
            },
            filters: {
                type: Array as PropType<AnyFilter[]>,
                required: true,
            },
        },

        setup(props) {

            // --- Data declarations ---
            const store = useStore();
            const mobileOpen = ref(false);
            const hasFilters = computed(() => {
                const x = Object.keys(store.getSelections.value);
                // console.log(x);
                return x.length > 0;
            });
            const name = computed(() => {
                let name = '';
                if (props.brand) {
                    name += props.brand.name;
                }
                if (props.category) {
                    name += ' ' + props.category.name;
                }
                return name;
            });
            const reset = () => {
                console.log('RESET');
                store.clearSelection();
            }

            return {
                reset,
                mobileOpen,
                name,
                hasFilters,
            }
        },

    });

